module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hPM61"))).then(() => parcelRequire('d0iPb'));